import React from 'react';
import PropTypes from 'prop-types';
import {Form} from 'formik';
import FieldInput from 'common/components/FieldInput';
import FieldSelect from 'common/components/FieldSelect';
import {
  limitFloatValueLength,
  limitIntegerValueLength
} from 'common/utils/form/limitValueLength';
import styles from './styles.module.scss';
import {ddOptions} from '../../../../common/constants/options';

const TabSurveyAssetsView = ({
                               customClassNames,
                               values,
                               options,
                               cityChangeProps,
                             }) => {

  return (
    <Form>
      <div
        className={`${customClassNames.tabContainer} ${styles.tabContainer}`}>
        <div className={styles.row}>
          <div className={styles.halfSize}>
            <FieldSelect
              fieldId="cityID"
              value={values.cityID}
              placeholder="עיר"
              label={(
                <div>
                  <span>*</span>
                  עיר
                </div>
              )}
              options={options.cities}
              isSearchable={true}
              isAsync={true}
              onChange={cityChangeProps.onChange}
              onReset={cityChangeProps.onReset}
            />
          </div>
          <div className={styles.halfSize}>
            <FieldSelect
              fieldId="streetID"
              type={'text'}
              value={values.streetID}
              placeholder="רחוב"
              label={(
                <div>
                  <span>*</span>
                  רחוב
                </div>
              )}
              options={options.streets}
              isSearchable={true}
              isAsync={true}
              defaultOptions={true}
              disabled={!values.cityID}
            />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.quaterSize}>
            <FieldInput
              fieldId="houseNum"
              value={values.houseNum}
              label="מספר בית / בניין"
            />
          </div>
          <div className={styles.quaterSize}>
            <FieldInput
              fieldId="houseRegisteredArea"
              onChange={limitFloatValueLength(6)}
              value={values.houseRegisteredArea}
              label='שטח במ"ר'
            />
          </div>
          <div className={styles.quaterSize}>
            <FieldInput
              fieldId="houseRoomCount"
              onChange={limitFloatValueLength(3)}
              value={values.houseRoomCount}
              label="מספר חדרים"
            />
          </div>
          <div className={styles.quaterSize}>
            <FieldInput
              fieldId="floor"
              onChange={limitIntegerValueLength(2)}
              value={values.floor}
              label="קומה"
            />
          </div>
        </div>
        <div className={`${styles.row} ${styles.halfSize}`}>
          <div className={styles.quaterSize}>
            <FieldInput
              fieldId="buildingFloorsCount"
              onChange={limitIntegerValueLength(2)}
              value={values.buildingFloorsCount}
              label="מספר קומות"
            />
          </div>
          <div className={styles.quaterSize}>
            <FieldInput
              fieldId="buildYear"
              onChange={limitIntegerValueLength(4)}
              value={values.buildYear}
              label="שנת בניה"
            />
          </div>
        </div>
        <div className={`${styles.row}`}>
          <div className={styles.quaterSize}>
            <FieldSelect
              fieldId="houseParking"
              placeholder="בחר"
              label="חניה צמודה"
              options={ddOptions}
            />
          </div>
          <div className={styles.quaterSize}>
            <FieldSelect
              fieldId="buildingElevator"
              placeholder="בחר"
              label="מעלית"
              options={ddOptions}
            />
          </div>
          <div className={styles.quaterSize}>
            <FieldSelect
              fieldId="houseYard"
              placeholder="בחר"
              label="חצר"
              options={ddOptions}
            />
          </div>
          <div className={styles.quaterSize}>
            <FieldSelect
              fieldId="houseStorage"
              placeholder="בחר"
              label="מחסן"
              options={ddOptions}
            />
          </div>
        </div>
        <div className={`${styles.row} ${styles.halfSize}`}>
          <div className={styles.quaterSize}>
            <FieldSelect
              fieldId="houseRoof"
              placeholder="בחר"
              label="גג"
              options={ddOptions}
            />
          </div>
          <div className={styles.quaterSize}>
            <FieldInput
              fieldId="houseBalconyCount"
              onChange={limitIntegerValueLength(3)}
              value={values.houseBalconyCount}
              label="מרפסת"
            />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.halfSize}>
            <FieldInput
              fieldId="askingPrice"
              onChange={limitIntegerValueLength(12)}
              value={values.askingPrice}
              label="מחיר מבוקש"
            />
          </div>
        </div>
        <div className={styles.row}>
          <FieldInput
            fieldId="marketingFactor"
            value={values.marketingFactor}
            label="הגורם המשווק"
          />
        </div>
        <div className={styles.buttons}>
          <button
            type="submit"
            className={styles.buttonSubmit}
          >
            <span>הוספת נכס</span>
          </button>
        </div>
      </div>
    </Form>
  );
};

TabSurveyAssetsView.propTypes = {
  customClassNames: PropTypes.object,
  values: PropTypes.object,
  options: PropTypes.object,
  cityChangeProps: PropTypes.shape({
    onChange: PropTypes.func,
    onReset: PropTypes.func,
  }).isRequired
};

export default TabSurveyAssetsView;
